<template>
  <v-container id="user-profile-view" fluid tag="section">
    <template>
      <v-card>
        <v-card-title>
          Nota
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="data"
          :options.sync="options"
          :server-items-length="totalData"
        >
          <template v-slot:item.tgl_nota="{ item }">
            <div>
              {{ formatDate(item.tgl_nota) }}
            </div>
          </template>
          <template v-slot:item.total_nota="{ item }">
            <div>
              {{
                formatCurrency(
                  Math.abs(item.i_total) +
                    Math.abs(item.ii_total) +
                    Math.abs(item.biaya_lain_total)
                )
              }}
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="d-md-none my-5"></div>
            <v-icon @click="deleteItem(item)"> mdi-delete </v-icon>
          </template>
        </v-data-table>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "ContainerView",
  data() {
    return {
      id: "",
      search: "",
      totalData: 0,
      data: [],
      loading: false,
      options: {},
      headers: [
        { text: "KV", value: "kv" },
        { text: "Tanggal Nota", value: "tgl_nota" },
        { text: "Nomor Nota", value: "nomor_nota" },
        { text: "Tanggal Lunas", value: "tgl_lunas" },
        { text: "Total Nota", value: "total_nota" },
        { text: "Actions", value: "actions", sortable: false, align: "center" }
      ]
    };
  },
  watch: {
    options: {
      handler() {
        this.fetchData();
      },
      deep: true
    },
    search() {
      this.fetchData();
    }
  },
  methods: {
    async fetchData() {
      this.loading = true;

      await axios
        .get(`invoice/invoice`, {
          params: {
            type: "paginate",
            limit: this.options.itemsPerPage,
            page: this.options.page,
            sortBy: this.options.sortBy[0] ? this.options.sortBy[0] : null,
            sortDesc: this.options.sortDesc[0]
              ? this.options.sortDesc[0]
              : null,
            search: this.search
          }
        })
        .then(res => {
          this.data = res.data.data;
          this.totalData = res.data.total;

          this.loading = false;
        })
        .catch(err => {
          this.loading = false;

          alert(err.response.data.message);
        });
    },
    async deleteItem(item) {
      if (!confirm("Apakah anda yakin ingin menghapus nota ini?")) return;

      this.loading = true;

      await axios
        .delete(`invoice/invoice/${item.nomor_nota}`)
        .then(res => {
          this.loading = false;

          this.fetchData();
        })
        .catch(err => {
          this.loading = false;
          alert(err.response.data.message);
        });
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    },
    formatDate(date) {
      const newDate = new Date(date);

      return `${String(newDate.getDate()).padStart(2, "0")}-${String(
        newDate.getMonth() + 1
      ).padStart(2, "0")}-${newDate.getFullYear()}`;
    }
  }
};
</script>
